import { action, observable } from 'mobx';
import { IEventHubDTO, IEventHubsDAO, IUpdateEventHubSubdomainDTO } from '../../../../../api/event-hubs.dao';
import { FormFieldProps, InitialData } from '../../../../../infrastructure/form-viewmodel-controller';
import { AbstractFormViewModelController } from '../../../../../infrastructure/implementations/form-viewmodel-controller';
import { configList, EventHubSubdomainFormField } from './event-hub-subdomain-form.config';
import { TObject } from '../../../../../infrastructure/type-extensions';
import { Container, Inject } from 'typescript-ioc';
import { EventHubsDAO } from '../../../../../api/implementations/event-hubs.dao';
import { IErrorParsing } from '../../../../../infrastructure/error-parsing';
import { alertServerError } from '../../../../global/modal/alerts-host/alert-templates';
import { errorText } from '../../../../../constants/common-labels.constants';


export class EventHubSubdomainFormVM {
    public static createFormVM(initialData: InitialData = {}): AbstractFormViewModelController {
        return new class extends AbstractFormViewModelController {
            constructor() {
                super(initialData, 'EventHubFormConfigurationController', configList);
            }
        }();
    }

    private formDataCtrl: AbstractFormViewModelController;

    @observable
    private loading: boolean = false;

    constructor(
        private readonly accountId: number,
        private readonly eventHub: IEventHubDTO,
        private readonly saveCompletedCallback: (eventHub: IEventHubDTO) => void,
        @Inject private readonly eventHubsDAO: IEventHubsDAO = Container.get(EventHubsDAO),
        @Inject private readonly errorParsingService: IErrorParsing = Container.get(IErrorParsing),
    ) {
    }

    public initialize(): void {
        const initialData = this.composeFormInitialData(this.eventHub);
        this.formDataCtrl = EventHubSubdomainFormVM.createFormVM(initialData);
    }

    public get isLoading(): boolean {
        return this.loading;
    }

    public getFormFields = (): TObject<FormFieldProps> => {
        const formFields = {};
        for (const key of Object.values(EventHubSubdomainFormField)) {
            formFields[key] = this.formDataCtrl.getFormVmValuePropsByKey(key);
        }
        return formFields;
    };

    public submitForm = (): Promise<boolean> => {
        if (!this.formDataCtrl.isVmValid()) {
            this.formDataCtrl.setVmTouched();
            return Promise.resolve(false);
        } else {
            return this.updateEventHubSubdomain();
        }
    };

    @action.bound
    public async updateEventHubSubdomain(): Promise<boolean> {
        this.startLoading();
        try {
            const dto = this.composeUpdateEventHubSubdomainDTO();
            const updatedEventHub = await this.eventHubsDAO.updateEventHubSubdomain(this.accountId, this.eventHub.eventHubId, dto);
            this.saveCompletedCallback(updatedEventHub);
            return true;
        } catch (error) {
            const errorMessage = this.errorParsingService.extractMessage(error);
            alertServerError(errorText(), errorMessage);
            return false;
        } finally {
            this.stopLoading();
        }
    }

    private composeFormInitialData(eventHub: IEventHubDTO): InitialData {
        return {
            subdomain: eventHub.subdomain || '',
        };
    }

    private composeUpdateEventHubSubdomainDTO(): IUpdateEventHubSubdomainDTO {
        return {
            subdomain: this.formDataCtrl.getValue(EventHubSubdomainFormField.SUBDOMAIN) as string || null
        };
    }

    @action
    private startLoading(): void {
        this.loading = true;
    }

    @action
    private stopLoading(): void {
        this.loading = false;
    }

}